import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Loader from '../../utils/Loader';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import {
	editChild,
	setShowEditChild,
} from '../../redux/parentDashboard/parentDashboard.actions';
import { setErrorPanel } from '../../redux/utilities/utils.actions';

const EditChild = ({
	editChild,
	panelClass,
	panelMsg,
	editChildDetails: { child_photo, child_name, child_grade, child_id },

	showEditChild,
	setShowEditChild,
	setErrorPanel,
}) => {
	const { register, handleSubmit, watch, errors } = useForm();
	const [imgSrc, setImgSrc] = useState([child_photo]);

	const onSubmit = (data) => {
		editChild({
			...data,
			child_id,
			is_delete: false,
		});
	};
	const watchChildPhoto = watch('child_photo', false);

	useEffect(() => {
		setImgSrc(child_photo);
	}, [child_photo]);

	useEffect(() => {
		var reader = new FileReader();
		if (!!watchChildPhoto && !!watchChildPhoto[0]) {
			reader.readAsDataURL(watchChildPhoto[0]);
			reader.onloadend = () => setImgSrc([reader.result]);
		}
	}, [watchChildPhoto]);

	useEffect(() => {
		Loader.hide();
		setErrorPanel({
			errorPanel: {
				panelClass: '',
				panelMsg: '',
			},
		});
	}, [setErrorPanel]);

	return (
		<Modal
			show={showEditChild}
			dialogClassName="modal-90w"
			onHide={() => setShowEditChild(false)}
			backdrop={true}
			keyboard={false}
			style={{ minWidth: '300px' }}
			className="add-child-modal"
		>
			<Modal.Header closeButton style={{ minWidth: '300px' }}>
				<h4 className="modal-title" style={{ width: '100%', textAlign: 'center' }}>
					Edit details
				</h4>
			</Modal.Header>
			<Modal.Body size="lg" style={{ minWidth: '300px' }}>
				<div className="message_box">
					<div className={panelClass}>{panelMsg}</div>
				</div>
				<form id="childProfileForm" onSubmit={handleSubmit(onSubmit)}>
					<div className="d-flex flex-column justify-content-center">
						<div className="form-group text-center" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="child_photo">
								<div className="profileImageContainer">
									<img
										className="profileImagePreview"
										alt="profile"
										src={imgSrc || '/assets/img/kid-avatar-boy.svg'}
									/>

									<i class="fa fa-camera upload-button"></i>
								</div>
							</label>
							<input
								className="filepond"
								name="child_photo"
								id="child_photo"
								accept="image/*"
								ref={register}
								type="file"
								multiple={false}
								style={{ display: 'none' }}
							/>
						</div>

						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="child_name">
								Please enter your child's name:
							</label>
							<input
								type="text"
								className="form-control"
								name="child_name"
								ref={register({
									required: true,
									// eslint-disable-next-line no-useless-escape
									pattern: /^[a-zA-Z\s\.]+$/i,
								})}
								defaultValue={child_name}
							/>
							<span className="profileError">
								{errors.child_name?.type === 'pattern' &&
									'Name should only contain alphabets'}
							</span>
							<span className="profileError">
								{errors.child_name?.type === 'required' && "Child's name is required"}
							</span>
						</div>
					</div>
					<div className="form-group">
						<label className="control-label" htmlFor="child_grade">
							Which Class/Grade is your child in?
						</label>
						<div>{child_grade}</div>
					</div>

					<Button type="submit" className="float-right" variant="primary">
						SAVE
					</Button>
				</form>
			</Modal.Body>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const { errorPanel: { panelClass, panelMsg } = {} } = state.rootReducer.utils;
	const { editChildDetails, showEditChild } = state.rootReducer.parentDetails;
	return {
		panelClass,
		panelMsg,
		editChildDetails,
		showEditChild,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		editChild: (val) => dispatch(editChild(val)),
		setShowEditChild: (val) => dispatch(setShowEditChild(val)),
		setErrorPanel: (errorText) => dispatch(setErrorPanel(errorText)),
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(EditChild);
